/* import noSalesRecordImage from "../../assetsStatic/NoSalesRecord.png";
import "../../styles/salesRecord/salesRecord.css";
import Template from "../Template";
import { BsFilter, BsSearch } from "react-icons/bs";
import SelectStoreTab from "../../components/tabs/SelectStoreTab";
import EachSalesRecord from "./EachSalesRecord";
import BarChart from "../../components/charts/BarChat";
import DoughnutChart from "../../components/charts/DoughnutChart";
import { useState, useLayoutEffect, useEffect } from "react";
import { getSalesRecordUrl, getCustomSalesRecordUrl } from "../../api/endpoints";
import { setUser } from "../../slice/webStoreUserSlice";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../components/uxCollections/Loaders";
import CustomeDateSearch from "../../components/filter/CustomeDateSearch";
import SalesRecordSkeleton from "../../components/uxCollections/skeletonLoader/salesRecord/SalesRecordSkeleton";
import { ArrowBigDown, ArrowDownToLine, MoveDown } from "lucide-react";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";

const SalesRecord = () => {
  const [filterRecordBasedOnStore, setFilterRecordBasedOnStore] = useState({ storeName: "All stores", storeId: "1" });
  const [resetStoreFilter, setResetStoreFilter] = useState(false);
  const [fetchCount, setFetchCount] = useState(0);
  const [salesRecordDay, setSalesRecordDay] = useState("");
  const [salesRecordList, setSalesRecordList] = useState(null);
  const [salesRecordListCopy, setSalesRecordListCopy] = useState(null);
  const [salesRecordListBeforePurchaseModeFilter, setSalesRecordListBeforePurchaseModeFilter] = useState(null);
  const [salesTotal, setSalesTotal] = useState(0);
  const [topThreeProducts, setTopThreeProducts] = useState(null); 
  const [salesChart, setSalesChart] = useState(null); 
  const [selectedTab, setSelectedTab] = useState("all");
  const [searchValue, setSearchValue] = useState("");
  const [newUser, setNewUser] = useState(false);
  const [isLoading, setIsLoading] = useState(true); //
  const [openCustomDateSearch, setOpenCustomDateSearch] = useState(false); 
  const [customDates, setCustomDates] = useState({ fromDate: "", toDate: "" });
  const [whichPageToRender, setWhichPageToRender] = useState("salesRecord"); // salesRecord || charts  on for mobile screens
  const userCurrency = useSelector((state) => state.webStoreUser.user.userCountryCurrencySymbol);
  console.log(userCurrency);

  useLayoutEffect(() => {
    setSalesRecordDay("Today");
    fetchSalesRecord();
    

    window.addEventListener("resize", () => {
      if (window.innerWidth > 900) {
        setWhichPageToRender("salesRecord");
      }
    });
  }, []);
  useLayoutEffect(() => {
    salesRecordList && computeTotal(salesRecordList);
  }, [salesRecordList]);
  useLayoutEffect(() => {
    console.log(customDates);
  }, [customDates]);

  useLayoutEffect(() => {
    console.log(whichPageToRender);

    if (salesRecordDay === "Today" || salesRecordDay === "Yesterday") {
      whichPageToRender === "charts" && fetchSalesRecord();
    } else {
   //    customed date 
      console.log(customDates);
      whichPageToRender === "charts" && fetchCustomSalesRecord(customDates.fromDate, customDates.toDate);
    }
  }, [whichPageToRender]);

//  refetch Sales according to sellected day or interval 
  useLayoutEffect(() => {
    if (salesRecordDay === "Today" || salesRecordDay === "Yesterday") {
      fetchSalesRecord();
    } else {
      

      fetchCustomSalesRecord(customDates.fromDate, customDates.toDate);
    }
  }, [salesRecordDay]);


  useLayoutEffect(() => {
    if (salesRecordList) {
      if (filterRecordBasedOnStore.storeName === "All stores") {
        setSalesRecordList((prev) => {
          return salesRecordListCopy;
        });
        setSelectedTab("all");
        setSalesRecordListBeforePurchaseModeFilter(salesRecordListCopy);
      } else {
        setSalesRecordList((prev) => {
          let newList = salesRecordListCopy.filter((record) => record.store.id === filterRecordBasedOnStore.storeId);
          setSalesRecordListBeforePurchaseModeFilter(newList);

          return newList;
        });
        setSelectedTab("all");
      }
    }
  }, [filterRecordBasedOnStore]);

 // /* filter according to salesMode online || inStore 
  useLayoutEffect(() => {
    console.log(salesRecordListBeforePurchaseModeFilter);
    if (selectedTab === "online") {
      setSalesRecordList((prev) => {
        return salesRecordListBeforePurchaseModeFilter.filter((record) => record.purchaseMode === "online");
      });
      console.log(salesRecordList);
    } else if (selectedTab === "inShop") {
      setSalesRecordList((prev) => {
        return salesRecordListBeforePurchaseModeFilter.filter((record) => record.purchaseMode === "inStore");
      });
      console.log(salesRecordList);
    } else {
      setSalesRecordList(salesRecordListBeforePurchaseModeFilter);
    }
  }, [selectedTab]);



  const dispatch = useDispatch();

 
  const fetchSalesRecord = async () => {
    setIsLoading(true);
    try {
      let response = await fetch(getSalesRecordUrl + salesRecordDay, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });

      if (response.ok) {
        let { user, salesRecords } = await response.json();
        console.log(salesRecords);
        dispatch(setUser(user));
        user.productsSoldInAllStores.length === 0 && setNewUser(true);
        setSalesRecordList(salesRecords);
        setSalesRecordListCopy(salesRecords);
        setSalesRecordListBeforePurchaseModeFilter(salesRecords);
        //computeTotal(salesRecords);
        findTopThreeProducts(user.productsSoldInAllStores);
        createSalesChart(user.salesChart);
        setSelectedTab("all");
        setFilterRecordBasedOnStore({ storeName: "All stores", storeId: "1" });

        setResetStoreFilter((prev) => !prev);
        setIsLoading(false);
        setFetchCount((prev) => prev + 1);
        console.log(fetchCount);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCustomSalesRecord = async (fromDate, toDate) => {
    setIsLoading(true);

    try {
      let response = await fetch(getCustomSalesRecordUrl + `${fromDate}/${toDate}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });
      if (response.ok) {
        let { user, salesRecords } = await response.json();
        dispatch(setUser(user));
        user.productsSoldInAllStores.length === 0 && setNewUser(true);
        setSalesRecordList(salesRecords);
        setSalesRecordListCopy(salesRecords);
        setSalesRecordListBeforePurchaseModeFilter(salesRecords);
        //computeTotal(salesRecords);
        findTopThreeProducts(user.productsSoldInAllStores);
        createSalesChart(user.salesChart);
        setSelectedTab("all");
        setFilterRecordBasedOnStore({ storeName: "All stores", storeId: "1" });
        setResetStoreFilter((prev) => !prev);
        setIsLoading(false);
        setFetchCount((prev) => prev + 1);
        console.log(fetchCount);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const showIntervalTab = () => {
    let tab = document.querySelector(".chooseInterval");
    tab.classList.toggle("update74653");
    tab.classList.toggle("showInterval");
  };

  const findTopThreeProducts = (productArray) => {
    console.log(productArray);
    let topThreeProducts = productArray
      .slice()
      .sort((a, b) => b.quantitySold - a.quantitySold)
      .slice(0, 3);

   // /* create an array of two array. first array is productName second is value 

    let topProductarray = topThreeProducts.reduce(
      (acc, cur) => {
        console.log(acc, cur);
        acc[0].push(cur.productName);
        acc[1].push(cur.quantitySold);
        return acc;
      },
      [[], []]
    );
    setTopThreeProducts(topProductarray);
  };

  const createSalesChart = (salesChartArray) => {
    // find the year 
    console.log(salesChartArray);

    try {
      let year = new Date().getFullYear();
      let salesChart = salesChartArray.find((chart) => chart.year === year); ///* an object 

      let salesChartArrayForBarChart = salesChart.stores.reduce(
        (acc, cur) => {
          cur.productsSoldPerMonth.forEach((store, index) => {
            if (acc[1].length > 11) {
              acc[1][index] += store.offlineSales;
              acc[0][index] += store.onlineSales;
            } else {
              console.log(cur.productsSoldPerMonth[index].offlineSales, cur.productsSoldPerMonth[index].onlineSales);
              acc[0].push(cur.productsSoldPerMonth[index].onlineSales);
              acc[1].push(cur.productsSoldPerMonth[index].offlineSales);
              acc[2].push(store.month);
            }
          });

          return acc;
        },
        [[], [], []]
      );

      setSalesChart(salesChartArrayForBarChart);
    } catch (error) {
      console.log(error);
    }
  };

  const computeTotal = (array) => {
    if (array.length === 0) {
      setSalesTotal(0);
      return;
    } else {
      let total = 0;
      array.forEach((item) => {
        total += item.totalPrice;
      });

      setSalesTotal(total);
    }
  };
  return (
    <>
      <Template>
        <h3 className='sRTitle22'>Sales Record</h3>
        <div className='customerFilter'>
          <SelectStoreTab updateSelectedStore={setFilterRecordBasedOnStore} resetFilter={resetStoreFilter} disableStoreFilter={false} />
          <div className='searchEmployeediv'>
            <input
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              className='SearchTransact1 searchWarehouse'
              placeholder='Enter product name'
            />
            <span>
              <BsSearch />
            </span>
          </div>
          <button
            onClick={() => {
              uiAlert("Your bankable report will be available after 8months since you created your business . Please contact support for more information.");
              return;
            }}
            className='downloadSalesRecord'
          >
            <ArrowDownToLine size={18} />
          </button>
        </div>

        <SwitchTab whichPageToRender={whichPageToRender} setWhichTabtorender={setWhichPageToRender} />
        {isLoading ? (
          <div className=''>
           
            <SalesRecordSkeleton />
          </div>
        ) : (
          <div className='uppea3664'>
            {newUser ? (
              <div className='SalesRecordWrapper noSalesRecordDiv'>
                {" "}
                <img src={noSalesRecordImage} />
                <h3> Your store analysis would be shown here </h3>
                <p>Start selling to see your store analysis</p>
                <p></p>
              </div>
            ) : whichPageToRender === "salesRecord" ? (
              <div className='SalesRecordWrapper'>
                <div>
                  <div className='TabFilterSR46 '>
                    <div className='SalesRTab8334'>
                      <p onClick={(e) => setSelectedTab("all")} className={selectedTab === "all" ? "selectedTabSR2843" : ""}>
                        All
                      </p>
                      <p onClick={(e) => setSelectedTab("inShop")} className={selectedTab === "inShop" ? "selectedTabSR2843" : ""}>
                        In Shop
                      </p>
                      <p onClick={(e) => setSelectedTab("online")} className={selectedTab === "online" ? "selectedTabSR2843" : ""}>
                        Online
                      </p>
                    </div>

                    <div
                      style={{ padding: "4px 6px", gap: "6px", alignItems: "center", color: "#0E49B5", fontWeight: "600", cursor: "pointer" }}
                      className='TimelineTransactions'
                    >
                      <BsFilter onClick={showIntervalTab} />
                      <span style={{ fontSize: "0.85rem" }} onClick={showIntervalTab}>
                        {salesRecordDay}
                      </span>
                      <div style={{ bottom: "-180px", left: "-180px", width: "175px", minHeight: "160px" }} className='chooseInterval update74653'>
                        <p
                          onClick={() => {
                            setSalesRecordDay("Today");
                            showIntervalTab();
                          }}
                        >
                          {" "}
                          Today
                        </p>
                        <p
                          onClick={() => {
                            setSalesRecordDay("Yesterday");
                            showIntervalTab();
                          }}
                        >
                          Yesterday
                        </p>
                        <p
                          onClick={() => {
                            setOpenCustomDateSearch(true);
                            showIntervalTab();
                          }}
                        >
                          choose interval
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className='EachRecordDiv374'>
                    {salesRecordList.length > 0 &&
                      salesRecordList
                        .filter((record) => record.name.toLowerCase().includes(searchValue.toLowerCase()))
                        .map((record) => <EachSalesRecord key={record._id} record={record} userCurrency={userCurrency} />)}
                  </div>
                </div>

                <div>
                  <div className='BarChatDIv23'>
                    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center" }}>
                      {salesChart ? (
                        <BarChart value={salesChart} userCurrency={userCurrency} />
                      ) : (
                      

                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: "0.9rem", fontWeight: "600" }}>
                          {" "}
                          No data yet
                        </div>
                      )}
                    </div>
                  </div>
                  {!salesChart && <p style={{ textAlign: "center", fontSize: "0.9rem", fontWeight: "700" }}>Too three selling products</p>}
                  <div style={{ marginTop: "4px", height: "250px" }} className='BarChatDIv23'>
                    <div> {topThreeProducts && <DoughnutChart value={topThreeProducts} confiq={{ title: "Top selling products" }} />}</div>
                  </div>
                </div>
              </div>
            ) : (
              <div style={{ height: "85%" }} className='showChatMonek726'>
                {" "}
                <div>
                  <div className='BarChatDIv23'>
                    <div style={{ width: "100%", height: "100%", display: "flex", justifyContent: "center" }}>
                      {salesChart ? (
                        <BarChart value={salesChart} />
                      ) : (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: "0.9rem", fontWeight: "600" }}>
                          {" "}
                          No data yet
                        </div>
                      )}
                    </div>
                  </div>
                  {!salesChart && <p style={{ textAlign: "center", fontSize: "0.9rem", fontWeight: "700" }}>Top three selling products</p>}
                  <div style={{ marginTop: "4px", height: "250px" }} className='BarChatDIv23'>
                    <div> {topThreeProducts && <DoughnutChart value={topThreeProducts} confiq={{ title: "Top selling products" }} />}</div>
                  </div>
                </div>
              </div>
            )}

            <div className='SalesRecDowlT56'>
              <div style={{ marginTop: "0" }} className='payoutTotalDIv23'>
                <p>Total</p>
                <p>
                  {userCurrency} {salesTotal?.toLocaleString()}
                </p>
              </div>
              {newUser ? (
                <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='DwloaSr34-btn'>
                  Download record
                </button>
              ) : (
                <button
                  onClick={() => {
                    uiAlert(
                      "Your bankable report will be available after 8months since you created your business . Please contact support for more information."
                    );
                    return;
                  }}
                  className='DwloaSr34-btn'
                >
                  Download record
                </button>
              )}
            </div>
          </div>
        )}
        {openCustomDateSearch && (
          <CustomeDateSearch
            closeModal={setOpenCustomDateSearch}
            setFetchCustomTrans={setCustomDates}
            setSalesTimeLine={setSalesRecordDay}
            disableDefault={true}
          />
        )}
      </Template>
    </>
  );
};

export default SalesRecord;

const SwitchTab = ({ whichPageToRender, setWhichTabtorender }) => {
  useLayoutEffect(() => {
    let movingTrain = document.querySelector(".movingTrain74trg");
    let activeTab = document.querySelector(".activeTab63654");
    let salesTab = document.getElementById("77343464");
    let chartsTab = document.getElementById("jf95858439");

    if (whichPageToRender === "salesRecord") {
      movingTrain.style.transform = "translateX(0%)";
      salesTab.classList.add("activeTab63654");
      chartsTab.classList.remove("activeTab63654");
    } else {
      movingTrain.style.transform = "translateX(102%)";
      chartsTab.classList.add("activeTab63654");
      salesTab.classList.remove("activeTab63654");
    }
  }, [whichPageToRender]);

  const handleSwitchTab = (e) => {};

  return (
    <>
      <div className='sTabWrapper33'>
        <div className='swtTabTrack22'>
          <div className='movingTrain74trg'></div>
          <div onClick={() => setWhichTabtorender("salesRecord")} id='77343464' className='activeTab63654'>
            Sales record
          </div>
          <div onClick={() => setWhichTabtorender("charts")} id='jf95858439'>
            Charts
          </div>
        </div>
      </div>
    </>
  );
}; */

import { useState, useMemo, useEffect, useRef } from "react";
import { Download, TrendingUp, TrendingDown, Wallet, Receipt, Store, Globe, Search, ChevronDown, SlidersHorizontal, BarChart3, X, Check } from "lucide-react";
import * as XLSX from "xlsx";

import "../../styles/salesRecord/salesRecord.css";
import Template from "../Template";
import { BsFilter, BsSearch } from "react-icons/bs";
import SelectStoreTab from "../../components/tabs/SelectStoreTab";
import EachSalesRecord from "./EachSalesRecord";
import BarChart from "../../components/charts/BarChat";
import DoughnutChart from "../../components/charts/DoughnutChart";
import { SalesTransactionCard } from "./SalesTransactionCard";
import { getSalesRecordUrl, getCustomSalesRecordUrl } from "../../api/endpoints";
import { setUser } from "../../slice/webStoreUserSlice";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "../../components/uxCollections/Loaders";
import CustomeDateSearch from "../../components/filter/CustomeDateSearch";
import SalesRecordSkeleton from "../../components/uxCollections/skeletonLoader/salesRecord/SalesRecordSkeleton";

import { uiAlert } from "../../components/alerts/customAlert/uiAlert";
import { Pagination } from "../productCatelog/ProductCatelog";
import { fmtC } from "../Transactions/TransactionPage";
import Loader from "../../components/uxCollections/storelensSpiner/StorelenseSpinner";

// npm install xlsx lucide-react
//
// Props:
//   salesRecords            — array of salesRecordModel documents
//   salesChart              — user.salesChart  [{ year, stores: [{ storeName, storeID, productsSoldPerMonth }] }]
//   productsSoldInAllStores — user.productsSoldInAllStores [{ productID, productName, storeID, storeName, quantitySold }]
//
// Self-contained page section (not an overlay) — drop it into a route/tab.
// No fetching happens in here; feed it the three pieces of data above
// however you already load them.

const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

const DATE_PRESETS = [
  { key: "today", label: "Today" },
  { key: "yesterday", label: "Yesterday" },
  { key: "thisWeek", label: "This Week" },
  { key: "thisMonth", label: "This Month" },
  { key: "thisYear", label: "This Year" },
  { key: "allTime", label: "All Time" },
  { key: "custom", label: "Custom" },
];

const STATUS_META = {
  paid: { label: "Paid", color: "#1f9d55", tint: "#edfcf0" },
  returned: { label: "Returned", color: "#a68b00", tint: "#fbf7dc" },
  disputed: { label: "Disputed", color: "#c23a3a", tint: "#ffe8e6" },
};

function formatCompactNumber(value) {
  if (value >= 1_000_000) return (value / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  if (value >= 1_000) return (value / 1_000).toFixed(1).replace(/\.0$/, "") + "K";
  return Math.round(value).toLocaleString();
}

// This assumes the following already exist in your codebase:
// getSalesRecordUrl, getCustomSalesRecordUrl, uiAlert, Spinner, Pagination
//
// salesRecordDay is sent as the chip's Title Case label — "Today",
// "Yesterday", "This Week", "This Month", "This Year", "All Time" —
// confirmed against your backend's `salesRecordDay === "Today"` check
// for the first two. I'm assuming the rest follow the same "This Week" /
// "This Month" / "This Year" / "All Time" pattern; if any of those don't
// match what your backend checks for, update the `label` values in
// DATE_PRESETS below to whatever exact strings it expects — the fetch
// pulls straight from there.

const SalesRecord = () => {
  const [salesRecords, setSalesRecords] = useState([]);
  const [salesChart, setSalesChart] = useState([]);
  const [productsSoldInAllStores, setProductsSoldInAllStores] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState("Fetching sales records");

  const [purchaseModeFilter, setPurchaseModeFilter] = useState("all"); // all | online | inStore
  const [storeFilter, setStoreFilter] = useState("all");
  const [datePreset, setDatePreset] = useState("thisMonth");
  const [customStart, setCustomStart] = useState("");
  const [customEnd, setCustomEnd] = useState("");
  const [search, setSearch] = useState("");
  const [filterSheetOpen, setFilterSheetOpen] = useState(false);
  const [insightsSheetOpen, setInsightsSheetOpen] = useState(false);

  // pagination — 100 records per fetch, server-driven
  const RECORDS_PER_PAGE = 100;
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currency, setCurrency] = useState("₦");

  const availableStores = useMemo(() => {
    const map = new Map();
    salesRecords.forEach((r) => {
      if (r.store?.id) map.set(String(r.store.id), r.store.name);
    });
    return [...map.entries()].map(([id, name]) => ({ id, name }));
  }, [salesRecords]);

  const applyFetchedData = (payload) => {
    const { user, salesRecords: records, pagination } = payload;
    setSalesRecords(records || []);
    setSalesChart(user?.salesChart || []);
    setProductsSoldInAllStores(user?.productsSoldInAllStores || []);
    setTotalPages(pagination?.totalPages || 1);
    setTotalRecords(pagination?.totalRecords ?? (records || []).length);
    setCurrency(user?.userCountryCurrencySymbol || "₦");
  };

  const fetchSalesRecord = async (salesRecordDay, pageToFetch = 1) => {
    setIsLoading(true);
    setLoadingProgress("Fetching sales records");
    try {
      let response = await fetch(getSalesRecordUrl + salesRecordDay + `?page=${pageToFetch}&limit=${RECORDS_PER_PAGE}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });

      if (response.ok) {
        let payload = await response.json();
        applyFetchedData(payload);
        setPage(pageToFetch);
      } else {
        uiAlert("something went wrong", "error");
      }
    } catch (error) {
      console.log(error);
      uiAlert("something went wrong", "error");
    } finally {
      setIsLoading(false);
      setHasLoadedOnce(true);
    }
  };

  const fetchCustomSalesRecord = async (fromDate, toDate, pageToFetch = 1) => {
    setIsLoading(true);
    setLoadingProgress("Fetching sales records");
    try {
      let response = await fetch(getCustomSalesRecordUrl + `${fromDate}/${toDate}` + `?page=${pageToFetch}&limit=${RECORDS_PER_PAGE}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("accessToken"),
        },
      });

      if (response.ok) {
        let payload = await response.json();
        applyFetchedData(payload);
        setPage(pageToFetch);
      } else {
        uiAlert("something went wrong", "error");
      }
    } catch (error) {
      console.log(error);
      uiAlert("something went wrong", "error");
    } finally {
      setIsLoading(false);
      setHasLoadedOnce(true);
    }
  };

  const handlePageChange = (nextPage) => {
    if (datePreset === "custom") {
      if (customStart && customEnd) fetchCustomSalesRecord(customStart, customEnd, nextPage);
      return;
    }
    const salesRecordDay = DATE_PRESETS.find((p) => p.key === datePreset)?.label;
    if (salesRecordDay) fetchSalesRecord(salesRecordDay, nextPage);
  };

  // fetch whenever the date preset changes; custom waits for both ends of the range.
  // always resets back to page 1 — a new period is a new result set.
  useEffect(() => {
    if (datePreset === "custom") {
      if (customStart && customEnd) fetchCustomSalesRecord(customStart, customEnd, 1);
      return;
    }
    const salesRecordDay = DATE_PRESETS.find((p) => p.key === datePreset)?.label;
    if (salesRecordDay) fetchSalesRecord(salesRecordDay, 1);
  }, [datePreset, customStart, customEnd]);

  const availableYears = useMemo(() => [...new Set(salesChart.map((y) => y.year))].sort((a, b) => b - a), [salesChart]);
  const [chartYear, setChartYear] = useState(new Date().getFullYear());

  // keep the selected chart year valid once real data comes in
  useEffect(() => {
    if (availableYears.length && !availableYears.includes(chartYear)) {
      setChartYear(availableYears[0]);
    }
  }, [availableYears]);

  // Mode, store, and search filters apply client-side to whatever page is
  // currently loaded — with pagination now in play, search only reaches the
  // 100 records on the current page, not the full result set. If you need
  // search across every record for the period, that has to become a query
  // param on the backend rather than a client-side filter.
  const filteredRecords = useMemo(() => {
    return salesRecords.filter((record) => {
      if (purchaseModeFilter !== "all" && record.purchaseMode !== purchaseModeFilter) return false;
      if (storeFilter !== "all" && String(record.store?.id) !== storeFilter) return false;

      if (search.trim()) {
        const q = search.trim().toLowerCase();
        const matches =
          record.name?.toLowerCase().includes(q) || record.customer?.fullName?.toLowerCase().includes(q) || record.store?.name?.toLowerCase().includes(q);
        if (!matches) return false;
      }

      return true;
    });
  }, [salesRecords, purchaseModeFilter, storeFilter, search]);

  const totalAmount = useMemo(
    () =>
      filteredRecords.reduce((sum, r) => {
        if (r.status === "returned") return sum;
        return sum + (r.totalPrice || 0);
      }, 0),
    [filteredRecords],
  );

  const statusCounts = useMemo(() => {
    const counts = { paid: 0, returned: 0, disputed: 0 };
    filteredRecords.forEach((r) => {
      if (counts[r.status] !== undefined) counts[r.status] += 1;
    });
    return counts;
  }, [filteredRecords]);

  const modeSplit = useMemo(() => {
    const split = { online: 0, inStore: 0 };
    filteredRecords.forEach((r) => {
      if (r.status === "returned") return;

      if (split[r.purchaseMode] !== undefined) split[r.purchaseMode] += r.totalPrice || 0;
    });
    return split;
  }, [filteredRecords]);

  // aggregate productsSoldInAllStores, respecting the store filter
  const productAggregates = useMemo(() => {
    const source = storeFilter === "all" ? productsSoldInAllStores : productsSoldInAllStores.filter((p) => String(p.storeID) === storeFilter);

    const map = new Map();
    source.forEach((entry) => {
      const key = String(entry.productID);
      const existing = map.get(key);
      if (existing) {
        existing.quantitySold += entry.quantitySold || 0;
      } else {
        map.set(key, { productID: entry.productID, productName: entry.productName, quantitySold: entry.quantitySold || 0 });
      }
    });
    return [...map.values()].sort((a, b) => b.quantitySold - a.quantitySold);
  }, [productsSoldInAllStores, storeFilter]);

  const topSelling = productAggregates.slice(0, 5);
  const lowSelling = useMemo(() => [...productAggregates].sort((a, b) => a.quantitySold - b.quantitySold).slice(0, 5), [productAggregates]);

  // aggregate the bar chart data for the selected year, respecting the store filter
  const chartData = useMemo(() => {
    const yearEntry = salesChart.find((y) => y.year === chartYear);
    const totals = MONTHS.map((month) => ({ month, offlineSales: 0, onlineSales: 0 }));

    if (yearEntry) {
      const storesToSum = storeFilter === "all" ? yearEntry.stores : yearEntry.stores.filter((s) => String(s.storeID) === storeFilter);

      storesToSum.forEach((store) => {
        store.productsSoldPerMonth.forEach((m) => {
          const row = totals.find((t) => t.month === m.month);
          if (row) {
            row.offlineSales += m.offlineSales || 0;
            row.onlineSales += m.onlineSales || 0;
          }
        });
      });
    }
    return totals;
  }, [salesChart, chartYear, storeFilter]);

  const chartMax = Math.max(1, ...chartData.map((d) => d.offlineSales + d.onlineSales));

  const activeFilterCount =
    (purchaseModeFilter !== "all" ? 1 : 0) + (storeFilter !== "all" ? 1 : 0) + (datePreset !== "allTime" ? 1 : 0) + (search.trim() ? 1 : 0);

  const handleExport = () => {
    if (filteredRecords.length === 0) return;

    const rows = filteredRecords.map((r) => ({
      Date: new Date(r.purchaseDate).toLocaleString(),
      Product: r.name,
      Customer: r.customer?.fullName || "—",
      Store: r.store?.name || "—",
      Mode: r.purchaseMode === "inStore" ? "In-Store" : "Online",
      Status: r.status,
      "Unit Price": r.unitPrice,
      Quantity: r.quantity,
      Total: r.totalPrice,
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    worksheet["!cols"] = [{ wch: 20 }, { wch: 22 }, { wch: 18 }, { wch: 16 }, { wch: 10 }, { wch: 10 }, { wch: 12 }, { wch: 10 }, { wch: 12 }];

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Record");

    const presetLabel = DATE_PRESETS.find((p) => p.key === datePreset)?.label || "records";
    XLSX.writeFile(workbook, `sales-record-${presetLabel.replace(/\s+/g, "-").toLowerCase()}.xlsx`);
  };
  // their own open/close state and outside-click ref, instead of colliding.
  const StoreDropdown = ({ storeFilter, setStoreFilter, availableStores }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
      function handleClickOutside(e) {
        if (ref.current && !ref.current.contains(e.target)) setOpen(false);
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const selectedLabel = storeFilter === "all" ? "All Stores" : availableStores.find((s) => s.id === storeFilter)?.name || "All Stores";

    return (
      <div className='sl-sales-record-store-dropdown' ref={ref}>
        <button
          type='button'
          className={"sl-sales-record-store-trigger" + (open ? " sl-sales-record-store-trigger--open" : "")}
          onClick={() => setOpen((o) => !o)}
        >
          <Store size={14} />
          <span>{selectedLabel}</span>
          <ChevronDown size={13} className='sl-sales-record-store-chevron' />
        </button>

        {open && (
          <div className='sl-sales-record-store-menu'>
            <button
              type='button'
              className={"sl-sales-record-store-option" + (storeFilter === "all" ? " sl-sales-record-store-option--active" : "")}
              onClick={() => {
                setStoreFilter("all");
                setOpen(false);
              }}
            >
              <Check size={13} className='sl-sales-record-store-check' />
              <span>All Stores</span>
            </button>
            {availableStores.map((s) => (
              <button
                type='button'
                key={s.id}
                className={"sl-sales-record-store-option" + (storeFilter === s.id ? " sl-sales-record-store-option--active" : "")}
                onClick={() => {
                  setStoreFilter(s.id);
                  setOpen(false);
                }}
              >
                <Check size={13} className='sl-sales-record-store-check' />
                <span>{s.name}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    );
  };

  // shared filter controls, used in the desktop toolbar and the mobile sheet
  const renderFilterControls = () => (
    <>
      <div className='sl-sales-record-mode-tabs'>
        {[
          { key: "all", label: "All Records", icon: Receipt },
          { key: "inStore", label: "In-Store", icon: Store },
          { key: "online", label: "Online", icon: Globe },
        ].map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            className={"sl-sales-record-mode-tab" + (purchaseModeFilter === key ? " sl-sales-record-mode-tab--active" : "")}
            onClick={() => setPurchaseModeFilter(key)}
          >
            <Icon size={14} />
            {label}
          </button>
        ))}
      </div>
      {/* 
      <div className='sl-sales-record-store-select'>
        <Store size={14} />
        <select value={storeFilter} onChange={(e) => setStoreFilter(e.target.value)}>
          <option value='all'>All Stores</option>
          {availableStores.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
        
      </div> */}
      <StoreDropdown storeFilter={storeFilter} setStoreFilter={setStoreFilter} availableStores={availableStores} />

      <div className='sl-sales-record-search'>
        <Search size={14} />
        <input type='text' placeholder='Search product, customer, store...' value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>

      <div className='sl-sales-record-date-chips'>
        {DATE_PRESETS.map(({ key, label }) => (
          <button
            key={key}
            className={"sl-sales-record-date-chip" + (datePreset === key ? " sl-sales-record-date-chip--active" : "")}
            onClick={() => setDatePreset(key)}
          >
            {label}
          </button>
        ))}
        {datePreset === "custom" && (
          <div className='sl-sales-record-custom-range'>
            <input type='date' value={customStart} onChange={(e) => setCustomStart(e.target.value)} />
            <span>to</span>
            <input type='date' value={customEnd} onChange={(e) => setCustomEnd(e.target.value)} />
          </div>
        )}
      </div>
    </>
  );

  // shared stats content, used in the desktop stats grid and the mobile insights sheet
  const renderStats = () => (
    <>
      <div className='sl-sales-record-stat sl-sales-record-stat--primary'>
        <Wallet size={18} />
        <div
          style={{
            display: "flex",
            gap: "20px",
            alignContent: "center",
            justifyContent: "space-between",
          }}
        >
          <span className='sl-sales-record-stat-value'>{fmtC(totalAmount, currency)}</span>
          <span className='sl-sales-record-stat-label'>Total Sales Amount</span>
        </div>
      </div>
      <div className='sl-sales-record-stat'>
        <span className='sl-sales-record-stat-value' style={{ color: STATUS_META.paid.color }}>
          {statusCounts.paid}
        </span>
        <span className='sl-sales-record-stat-label'>Sold</span>
      </div>
      <div className='sl-sales-record-stat'>
        <span className='sl-sales-record-stat-value' style={{ color: STATUS_META.returned.color }}>
          {statusCounts.returned}
        </span>
        <span className='sl-sales-record-stat-label'>Returned</span>
      </div>
      <div className='sl-sales-record-stat'>
        <span className='sl-sales-record-stat-value' style={{ color: STATUS_META.disputed.color }}>
          {statusCounts.disputed}
        </span>
        <span className='sl-sales-record-stat-label'>Disputed</span>
      </div>
      <div className='sl-sales-record-stat'>
        <span className='sl-sales-record-stat-value' style={{ color: "#37b4c5" }}>
          {currency}
          {modeSplit.inStore.toLocaleString()}
        </span>
        <span className='sl-sales-record-stat-label'>In-Store</span>
      </div>
      <div className='sl-sales-record-stat'>
        <span className='sl-sales-record-stat-value' style={{ color: "#2563eb" }}>
          {currency}
          {modeSplit.online.toLocaleString()}
        </span>
        <span className='sl-sales-record-stat-label'>Online</span>
      </div>
    </>
  );

  // chart geometry
  const chartTop = 20;
  const chartHeight = 260;
  const chartBottom = chartTop + chartHeight;
  const chartStartX = 64;
  const slot = 62;

  if (isLoading && !hasLoadedOnce) {
    return (
      <Template>
        <div className='sl-sales-record-loading'>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "calc(100vh - 160px)" }}>
            <>
              <Loader size={70} />
            </>
          </div>
        </div>
      </Template>
    );
  }

  return (
    <Template>
      <div className='sl-sales-record'>
        {isLoading && hasLoadedOnce && (
          <div className='sl-sales-record-refresh-bar'>
            <span className='sl-sales-record-refresh-dot' />
            Updating records...
          </div>
        )}
        <div className='sl-sales-record-header'>
          <div>
            <h2>Sales Record</h2>
            <p>
              {totalRecords.toLocaleString()} transaction{totalRecords === 1 ? "" : "s"}
              {totalPages > 1 ? ` · page ${page} of ${totalPages}` : ""}
            </p>
          </div>
          <button className='sl-sales-record-export-btn' onClick={handleExport} disabled={filteredRecords.length === 0}>
            <Download size={15} />
            <span>Export</span>
          </button>
        </div>

        {/* desktop filter controls */}
        <div className='sl-sales-record-controls-desktop'>
          <div className='sl-sales-record-toolbar'>{renderFilterControls()}</div>
        </div>

        {/* mobile compact controls */}
        <div className='sl-sales-record-controls-mobile'>
          <button className='sl-sales-record-compact-btn' onClick={() => setFilterSheetOpen(true)}>
            <SlidersHorizontal size={14} />
            Filters
            {activeFilterCount > 0 && <span className='sl-sales-record-compact-badge'>{activeFilterCount}</span>}
          </button>
          <button className='sl-sales-record-compact-btn' onClick={() => setInsightsSheetOpen(true)}>
            <BarChart3 size={14} />
            Insights
          </button>
        </div>

        {/* desktop stats grid */}
        <div className='sl-sales-record-stats sl-sales-record-stats--desktop'>{renderStats()}</div>

        <div className='sl-sales-record-grid'>
          <div className='sl-sales-record-chart-card'>
            <div className='sl-sales-record-chart-header'>
              <h4>Products Sold by Month</h4>
              <div className='sl-sales-record-year-select'>
                <select value={chartYear} onChange={(e) => setChartYear(Number(e.target.value))}>
                  {(availableYears.length ? availableYears : [chartYear]).map((y) => (
                    <option key={y} value={y}>
                      {y}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className='sl-sales-record-chart-legend'>
              {(purchaseModeFilter === "all" || purchaseModeFilter === "inStore") && (
                <span>
                  <i style={{ background: "#37b4c5" }} /> In-Store
                </span>
              )}
              {(purchaseModeFilter === "all" || purchaseModeFilter === "online") && (
                <span>
                  <i style={{ background: "#2563eb" }} /> Online
                </span>
              )}
            </div>

            <div className='sl-sales-record-chart-scroll'>
              <svg viewBox='0 0 800 330' className='sl-sales-record-chart-svg' preserveAspectRatio='xMidYMid meet'>
                {[0, 0.25, 0.5, 0.75, 1].map((t) => {
                  const y = chartBottom - t * chartHeight;
                  const value = Math.round(chartMax * t);
                  return (
                    <g key={t}>
                      <line x1={chartStartX} x2='792' y1={y} y2={y} stroke='#edece6' strokeWidth='1' />
                      <text x={chartStartX - 8} y={y + 3} fontSize='15' fill='#8a8f98' textAnchor='end' fontFamily="'DM Mono', monospace">
                        {formatCompactNumber(value)}
                      </text>
                    </g>
                  );
                })}
                <line x1={chartStartX} x2={chartStartX} y1={chartTop} y2={chartBottom} stroke='#c9c7bd' strokeWidth='1' />
                <line x1={chartStartX} x2='792' y1={chartBottom} y2={chartBottom} stroke='#c9c7bd' strokeWidth='1' />

                {chartData.map((d, i) => {
                  const x = chartStartX + 6 + i * slot;
                  const barW = purchaseModeFilter === "all" ? 12 : 18;
                  const offlineH = purchaseModeFilter !== "online" ? (d.offlineSales / chartMax) * chartHeight : 0;
                  const onlineH = purchaseModeFilter !== "inStore" ? (d.onlineSales / chartMax) * chartHeight : 0;
                  return (
                    <g key={d.month}>
                      {purchaseModeFilter !== "online" && <rect x={x} y={chartBottom - offlineH} width={barW} height={offlineH} rx='2' fill='#37b4c5' />}
                      {purchaseModeFilter !== "inStore" && (
                        <rect
                          x={purchaseModeFilter === "all" ? x + barW + 4 : x}
                          y={chartBottom - onlineH}
                          width={barW}
                          height={onlineH}
                          rx='2'
                          fill='#2563eb'
                        />
                      )}
                      <text x={x + barW} y={chartBottom + 20} fontSize='15.5' fill='#8a8f98' textAnchor='middle' fontFamily="'Nunito', sans-serif">
                        {d.month.slice(0, 3)}
                      </text>
                    </g>
                  );
                })}
              </svg>
            </div>
          </div>

          <div className='sl-sales-record-side'>
            <div className='sl-sales-record-list-card'>
              <h4>
                <TrendingUp size={14} /> Top Selling Products
              </h4>
              {topSelling.length === 0 ? (
                <p className='sl-sales-record-list-empty'>No product sales data yet.</p>
              ) : (
                topSelling.map((p, i) => (
                  <div className='sl-sales-record-list-row' key={p.productID}>
                    <span className='sl-sales-record-rank sl-sales-record-rank--top'>{i + 1}</span>
                    <span className='sl-sales-record-list-name'>{p.productName}</span>
                    <span className='sl-sales-record-list-qty'>{p.quantitySold.toLocaleString()}</span>
                  </div>
                ))
              )}
            </div>

            <div className='sl-sales-record-list-card'>
              <h4>
                <TrendingDown size={14} /> Low Selling Products
              </h4>
              {lowSelling.length === 0 ? (
                <p className='sl-sales-record-list-empty'>No product sales data yet.</p>
              ) : (
                lowSelling.map((p, i) => (
                  <div className='sl-sales-record-list-row' key={p.productID}>
                    <span className='sl-sales-record-rank sl-sales-record-rank--low'>{i + 1}</span>
                    <span className='sl-sales-record-list-name'>{p.productName}</span>
                    <span className='sl-sales-record-list-qty'>{p.quantitySold.toLocaleString()}</span>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>

        <div className='sl-sales-record-table-card'>
          <h4>Transactions</h4>

          {/* desktop table */}
          <div className='sl-sales-record-table-wrap'>
            <table className='sl-sales-record-table'>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Product</th>
                  <th>Customer</th>
                  <th>Store</th>
                  <th>Mode</th>
                  <th>Status</th>
                  <th>Qty</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {filteredRecords.length === 0 ? (
                  <tr>
                    <td colSpan={8} className='sl-sales-record-table-empty'>
                      No sales records match these filters.
                    </td>
                  </tr>
                ) : (
                  filteredRecords.map((r) => {
                    const meta = STATUS_META[r.status] || STATUS_META.paid;
                    return (
                      <tr key={r._id}>
                        <td>{new Date(r.purchaseDate).toLocaleDateString()}</td>
                        <td>{r.name}</td>
                        <td>{r.customer?.fullName || "—"}</td>
                        <td>{r.store?.name || "—"}</td>
                        <td>{r.purchaseMode === "inStore" ? "In-Store" : "Online"}</td>
                        <td>
                          <span className='sl-sales-record-status-badge' style={{ color: meta.color, background: meta.tint }}>
                            {meta.label === "Paid" ? "Sold" : meta.label}
                          </span>
                        </td>
                        <td>{r.quantity}</td>
                        <td>
                          {currency}
                          {(r.totalPrice || 0).toLocaleString()}
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* mobile cards */}
          <div className='sl-sales-record-txn-cards'>
            {filteredRecords.length === 0 ? (
              <p className='sl-sales-record-table-empty'>No sales records match these filters.</p>
            ) : (
              filteredRecords.map((r) => <SalesTransactionCard key={r._id} record={r} currency={currency} />)
            )}
          </div>

          {totalPages > 1 && <Pagination current={page} total={totalPages} onChange={handlePageChange} limit={RECORDS_PER_PAGE} />}
        </div>

        {/* mobile filter sheet */}
        {filterSheetOpen && (
          <div className='sl-sales-record-sheet-overlay' onClick={() => setFilterSheetOpen(false)}>
            <div className='sl-sales-record-sheet' onClick={(e) => e.stopPropagation()}>
              <div className='sl-sales-record-sheet-handle' />
              <div className='sl-sales-record-sheet-header'>
                <h4>Filters</h4>
                <button onClick={() => setFilterSheetOpen(false)}>
                  <X size={16} />
                </button>
              </div>
              <div className='sl-sales-record-sheet-body'>{renderFilterControls()}</div>
              <div className='sl-sales-record-sheet-footer'>
                <button className='sl-sales-record-sheet-apply-btn' onClick={() => setFilterSheetOpen(false)}>
                  Show {filteredRecords.length.toLocaleString()} result{filteredRecords.length === 1 ? "" : "s"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* mobile insights sheet */}
        {insightsSheetOpen && (
          <div className='sl-sales-record-sheet-overlay' onClick={() => setInsightsSheetOpen(false)}>
            <div className='sl-sales-record-sheet' onClick={(e) => e.stopPropagation()}>
              <div className='sl-sales-record-sheet-handle' />
              <div className='sl-sales-record-sheet-header'>
                <h4>Insights</h4>
                <button onClick={() => setInsightsSheetOpen(false)}>
                  <X size={16} />
                </button>
              </div>
              <div className='sl-sales-record-sheet-body'>
                <div className='sl-sales-record-stats sl-sales-record-stats--sheet'>{renderStats()}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Template>
  );
};

export default SalesRecord;
